<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow' : visible}"
    :style="visible ? 'display:block;': ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center mt-4">
            <span class="material-icons text-blue-2" style="font-size: 77px"> thumb_up </span>
          <h5 class="modal-title">Tu compra se ha realizado correctamente!</h5>
          <p class="pt-3">Pronto se te enviará información sobre la misma. <br>Su compra está en proceso, estamos esperando confirmación del vendedor.</p>          
        </div>
        <div class="p-3 text-center">
          <span class="btn btn-treid" @click="handleClilickSend">Aceptar</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalNewBuy",
  props: {
    visible: Boolean
  },
  methods: {
    handleClilickSend(){
      this.$router.push('/');
    }
  }
};
</script>
<style lang="css" scoped>
</style>